import {POLICIES} from "../constants/policies";

// Политики, которые бот не покупает в начале партии: пока идет раунд не позже
// BOT_EARLY_FORBIDDEN_POLICIES_LAST_ROUND (включительно), они для него закрыты
// вовсе, со следующего раунда — на общих условиях (см. findBotPolicyToBuy).
// Считается раунд ПОКУПКИ, а не раунд, с которого политика действует (первая
// политика игрока и любая покупка людей действуют сразу, замена у остальных
// фракций — со следующего раунда).
//
// Запрет общий: любой бот в любой партии — непомеченный и явный в сетевых и
// рейтинговых матчах, бот локальной партии, кампании и демо главного меню,
// ИИ-игрок на автопилоте. Условий по виду бота, лиге, фракции и составу
// соперников нет.
//
// Запрет — на покупку. Уже действующую политику из списка (купил не движок
// бота: ИИ-игрок до ухода на автопилот, админ при ручном управлении ботом)
// бот оценивает как обычно и из-за запрета не меняет.
//
// Против игрока с форой новичка «Экоанархизм» закрыт ботам и после этих
// раундов — до конца партии (см. configs/lowRatingAdvantage)
export const BOT_EARLY_FORBIDDEN_POLICIES = [POLICIES.ECOANARCHISM];
export const BOT_EARLY_FORBIDDEN_POLICIES_LAST_ROUND = 5;
